export default function()
{
    const self = this;

    /**
     * The header element where the video element is in
     * @type {jQuery}
     */
    self.$header = $('.section-movie-single-header');

    /**
     * The wrapper around the video element
     * @type {jQuery}
     */
    self.$videoWrapper = self.$header.find('.movie-single-header-video-wrapper');

    /**
     * The button that shows the video fullscreen
     * @type {jQuery}
     */
    self.$fullscreenButtons = $('.movie-single-header-video-fullscreen')
        .add('.movie-single-trailer-mobile-trigger');

    /**
     * The width of the window, to see if it's mobile or not
     * @type {Number}
     */
    self.windowWidth = $(window).width();

    /**
     * The amount of pixels below which the screen is considered mobile
     * @type {Number}
     */
    self.mobileBreakpoint = 768;

    /**
     * Enable the playing mechanism of the video
     * @return {void}
     */
    self.enablePlaying = () => {
        // Stop if the video element doesn't exist on the page
        const $video = self.$videoWrapper.find('video');
        if (! $video.length) {
            return null;
        }

        const videoElement = $video.get(0);

        setTimeout(() => {
            // Show the video to the front, by hiding other elements
            self.makeVideoVisible();

            // Show the poster again, after the video has ended
            $video.on('ended', () => {
                self.makeVideoInvisible();
            });

            // Play the video
            if (self.windowWidth >= self.mobileBreakpoint) {
                videoElement.play();
            }
        }, 2000);
    };

    /**
     * Hide elements, show the video
     * @return {void}
     */
    self.makeVideoVisible = () => {
        if (self.windowWidth >= self.mobileBreakpoint) {
            self.$header.find('.movie-single-header-poster').animate({ opacity: 0 });
            self.$header.find('.movie-single-header-oneliner').animate({ opacity: 0 });
            self.$fullscreenButtons.animate({ opacity: 1 });
        }
    };

    /**
     * Show elements, hide the video
     * @return {void}
     */
    self.makeVideoInvisible = () => {
        if (self.windowWidth >= self.mobileBreakpoint) {
            self.$header.find('.movie-single-header-poster').animate({ opacity: 1 });
            self.$header.find('.movie-single-header-oneliner').animate({ opacity: 1 });
            self.$fullscreenButtons.animate({ opacity: 0 });
        }
    };

    /**
     * Enable the fullscreen button click event
     * @return {void}
     */
    self.enableFullScreenButton = () => {
        // Stop if the video element doesn't exist on the page
        const $video = self.$videoWrapper.find('video');
        if (! $video.length) {
            return;
        }

        const videoElement = $video.get(0);

        // Mute the video when exiting fullscreen
        $video.on('fullscreenchange', () => {
            const fullscreenElement = document.fullscreenElement || document.mozFullScreenElement
                || document.webkitFullscreenElement || document.msFullscreenElement;

            if (! fullscreenElement) {
                videoElement.muted = true;

                // Pause when closed on mobile
                if (self.windowWidth < self.mobileBreakpoint) {
                    videoElement.pause();
                }
            }
        });

        self.$fullscreenButtons.on('click', event => {
            event.preventDefault();

            const rfs = videoElement.requestFullscreen || videoElement.webkitRequestFullScreen || videoElement.mozRequestFullScreen || videoElement.msRequestFullscreen;

            rfs.call(videoElement);

            // videoElement.requestFullscreen();
            videoElement.muted = false;

            // Play the video when on mobile
            if (self.windowWidth < self.mobileBreakpoint) {
                videoElement.play();
            }
        });
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/MovieHeaderVideo.js